import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TableHeader from "@/components/Every24HoursReportPreviewParts/TableHeader.vue";
import TableRow from "@/components/Every24HoursReportPreviewParts/TableRow.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import {
  TITLE_HEADERS,
  DRIVING_DETAIL_HEADERS,
  DRIVING_DETAIL_ROWS
} from "@/services/consts/every_24_hours_report";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderTitleAndDrivingDetail',
  props: {
    deliveryPlan: {},
    index: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_table, {
      class: "mx-auto col-12",
      style: {"width":"85%"},
      density: "compact"
    }, {
      default: _withCtx(() => [
        _createVNode(TableHeader, {
          headers: _unref(TITLE_HEADERS),
          deliveryPlan: props.deliveryPlan
        }, null, 8, ["headers", "deliveryPlan"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_table, {
      class: "mx-auto col-12",
      style: {"width":"85%"},
      density: "compact"
    }, {
      default: _withCtx(() => [
        _createVNode(TableHeader, { headers: _unref(DRIVING_DETAIL_HEADERS) }, null, 8, ["headers"]),
        _createVNode(TableRow, {
          deliveryPlan: props.deliveryPlan,
          index: props.index,
          rowItems: _unref(DRIVING_DETAIL_ROWS)
        }, null, 8, ["deliveryPlan", "index", "rowItems"])
      ]),
      _: 1
    })
  ], 64))
}
}

})